import { IResponse, consumer, postFile } from "@bemap/utils";
import { IUser, IChangePassword } from "@bemap/utils";

const ENDPOINT = '/users';

export const searchUser = async (id: number): Promise<IResponse> => {
  return consumer('GET', ENDPOINT, undefined, id);
}

export const updateUser = async (payload: Partial<IUser>): Promise<IResponse> => {
  return consumer('PATCH', ENDPOINT, payload, payload.id);
}

export const updatePassword = async (id: number, payload: IChangePassword): Promise<IResponse> => {
  return consumer('PATCH', ENDPOINT, payload, `${id}/update-password`);
}

export const uploadProfilePhoto = async (userId: number, payload: FormData): Promise<IResponse> => {
  return postFile(`/users/${userId}/profile-photo`, payload,);
} 